<template>
    <div class="footer">
        <div class="container">
            <img class="me-lg-4" src="@/img/pirelli.svg" alt="Pirelli"/>
            <div class=" footer__menu">
                <a :href="documents.privacy_policy?.static_url" target="_blank" class="" v-dompurify-html="documents.privacy_policy?.label||'Polityka prywatności'"/>
                <template v-if="isLoggedIn && !isPlug">
                    <a :href="documents.regulation?.static_url" target="_blank" class="" v-dompurify-html="documents.regulation?.label||'Regulamin'"/>
<!--                    <router-link :to="{name: 'home'}" class="">Pliki Cookie</router-link>-->
                    <a href="https://akademiakpp.baseon.com/login" target="_blank" class="">Akademia Klubu Partnerów Pirelli</a>
                    <router-link :to="{name: 'guardian-logged'}" class="">Znajdź opiekuna</router-link>
                </template>
                <router-link v-else :to="{name: 'guardian'}" class="">Znajdź opiekuna</router-link>
                <br class="d-none d-md-inline"/>
            </div>
            <footer-info-component class="text-center text-lg-end ms-lg-4"/>
        </div>
    </div>
</template>

<script>
import FooterInfoComponent from "@/components/modules/FooterInfoComponent";

export default {
    name: "FooterComponent",
    inject:['documents'],
    props:{
      isPlug:{
          type: Boolean,
          default: false
      }
    },
    components: {FooterInfoComponent},
    computed:{
        isLoggedIn(){
            return this.$store.getters.isLoggedIn;
        }
    }
}
</script>

<style lang="scss">
.footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 3rem 0 1.5rem;
    @media (max-width: 991px) {
        position: relative;
    }
    @media (max-width: 767px) {
        padding-top: 1.5rem;
    }
    .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        @media screen and (max-width: 1499px){
            align-items: start;
        }
        @media (max-width: 991px) {
            flex-direction: column;
            justify-content: center;
            align-items: center;
            row-gap: 1.5rem;
        }
    }
    &__menu{
        @media screen and (max-width: 1499px){
            display: flex;
            text-align: center;
            flex-direction: column;
        }
        a{
            color: white;
            margin: 0 1.25rem;
            font-weight: normal;
            @media screen and (max-width: 1499px){
                margin: 0 0.75rem 1rem;
            }
        }
    }
}
</style>
